export type DateString = string & { __dt_tag: void };

export const getDate = (daysOffset: number) => {
  return new Date(new Date(Date.now() + 1000 * 60 * 60 * 24 * daysOffset).toDateString())
}

export const getDateString = (d: Date): DateString => new Date(d.getTime() - new Date().getTimezoneOffset() * 1000 * 60).toISOString().slice(0, 10) as DateString;

/** this is workaround for https://github.com/OpenAPITools/openapi-generator/issues/5932 */
export const updateDateByTimezone = (d: Date) => new Date(d.getTime() - new Date().getTimezoneOffset() * 1000 * 60);

export const APPLICATION_TIME_ZONE = 'Europe/Warsaw';

/**
 * Aktualny czas wg zegara aplikacji (Europe/Warsaw) zwrocony jako data lokalna,
 * dzieki czemu porownania z datami promocji dzialaja tak samo jak na backendzie
 * niezaleznie od strefy czasowej przegladarki.
 */
export const getApplicationNow = (): Date => {
  const now = new Date();
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: APPLICATION_TIME_ZONE,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
      .formatToParts(now)
      .reduce((memo: { [key: string]: number }, { type, value }) => {
        if (type !== 'literal') {
          memo[type] = parseInt(value, 10);
        }
        return memo;
      }, {});
    return new Date(parts.year, parts.month - 1, parts.day, parts.hour % 24, parts.minute, parts.second);
  } catch (e) {
    return now;
  }
};
